module.exports = __webpack_public_path__ + "img/tittle1.87eb86d0.png";